import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Container, Grid, Typography, Hidden } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import DataAccess from '../../api/constants';
import Moment from 'moment';
import { genfunction } from '../../helpers';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { actionShopCartSetManageMyBooking, actionShopCartSetRefundType, actionShopCartSetMmbAmountToPay, actionShopCartResetMembership, actionGetTransactionFee, actionShopCartResetIDME, actionShopCartSetEnteredAmountToPay } from 'actions';
import { actionGetBookingTypes, actionResetBookingTypes } from 'actions';
import { actionGetExtraItems, actionResetExtraItems } from 'actions';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import { actionResetBooking } from 'actions';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';

const { ShowReadableBarcode, TransactionFeeProductID, ApplyTransactionFee } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px'
    },
    tourheaderboxMobView: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px',
        marginTop: '40px'
    },
    image: {
        border: "5px solid white",
        padding: '10px',
        align: 'center'
    },
    warningMsg: {
        color: 'Red'
    },
    AdjustContext: {
        padding: '12px'
    },
    hideBtn: {
        display: 'none'
    }
}));

const ManageMyBooking = (props) => {

    const dispatch = useDispatch();

    //States Initializing Start

    const [open, setOpen] = React.useState(false);
    const [openPaymentmethod, setOpenPaymentMethod] = React.useState(false);

    //States Initializing End


    //Set States  Start

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const handleClickOpenPaymentMethod = () => {
        setOpenPaymentMethod(true);
    };

    const handleClosePaymentMethod = () => {
        setOpenPaymentMethod(false);
    };

    //Set States  End

    const classes = useStyles();
    const reducerBooking = useSelector(state => state.reducerBooking);
    const displayAreasState = useSelector(state => state.reducerDisplayAreas);
    const tourEvents = useSelector(state => state.reducerExtraItems);
    const bookingTypes = useSelector(state => state.reducerBookingTypes);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);

    const [errorMsg, seterrorMsg] = React.useState('');

    window.history.pushState({ name: "browserBack" }, "on browser back click", window.location.href);

    useEffect(() => {
        if (tourEvents.loading == true) {
            actionStartAppLoader(dispatch);
        }
        else {
            actionEndAppLoader(dispatch);
        }
    })

    useEffect(() => {
        if (ApplyTransactionFee && TransactionFeeProductID > 0) {
            actionGetTransactionFee(dispatch, TransactionFeeProductID, 'transactionfee');
        }
    }, [])

    useEffect(() => {
        if (bookingTypes.bookingTypesError && bookingTypes.bookingTypesError.length > 0) {
            seterrorMsg(bookingTypes.bookingTypesError);
        }
    }, [bookingTypes]);

    useEffect(() => {
        if (tourEvents.extramItemsError && tourEvents.extramItemsError.length > 0) {
            seterrorMsg(tourEvents.extramItemsError);
        }
    }, [tourEvents]);


    const errorcancelhandle = () => {
        seterrorMsg('');
        if (tourEvents.extramItemsError && tourEvents.extramItemsError.length > 0) {
            actionResetExtraItems(dispatch);
        }

        if (bookingTypes.bookingTypesError && bookingTypes.bookingTypesError.length > 0) {
            actionResetBookingTypes(dispatch);
        }
    }

    useEffect(() => {

        let displayareaNo = reducerBooking && reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BookingTypeDisplayArea') ? reducerBooking.booking[0].BookingTypeDisplayArea : 0;

        if (reducerBooking && reducerBooking.booking[0]) {

            if (reducerBooking.booking[0].AllowDateTimeChanges && !reducerBooking.booking[0].AllowDateTimeChangesWithinArea) {

                if (bookingTypes && bookingTypes.bookingTypes && bookingTypes.bookingTypes.length >= 0 && bookingTypes.bookingTypes.filter(x => x.BookingTypeID === reducerBooking.booking[0].BookingTypeID).length < 1) {
                    actionGetBookingTypes(dispatch, reducerBooking.booking[0].BookingTypeID, false);
                }
            }
            else if (reducerBooking.booking[0].hasOwnProperty('AllowDateTimeChangesWithinArea') && reducerBooking.booking[0].AllowDateTimeChangesWithinArea) {
                actionGetBookingTypes(dispatch, displayareaNo, true);
            }
        }

    }, [reducerBooking]);

    useEffect(() => {
        let startFilterDate = reducerBooking && reducerBooking.booking[0] ? reducerBooking.booking[0].EventStartDateTime : '';
        let bookingID = reducerBooking && reducerBooking.booking[0] ? reducerBooking.booking[0].BookingTypeID : 0;
        startFilterDate = Moment(startFilterDate).format('YYYY-MM-DD');

        if (reducerBooking && reducerBooking.booking[0]) {
            if (reducerBooking.booking[0].AllowDateTimeChanges && !reducerBooking.booking[0].AllowDateTimeChangesWithinArea) {
                actionGetExtraItems(dispatch, bookingID, true, false, startFilterDate, null, "SingleDay");
            }
        }

    }, [bookingTypes.bookingTypes]);


    useEffect(() => {
        let startFilterDate = reducerBooking && reducerBooking.booking[0] ? reducerBooking.booking[0].EventStartDateTime : '';
        startFilterDate = Moment(startFilterDate).format('YYYY-MM-DD');

        if (reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('AllowDateTimeChangesWithinArea') && reducerBooking.booking[0].AllowDateTimeChangesWithinArea) {

            let displayareaNo = reducerBooking && reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BookingTypeDisplayArea') ? reducerBooking.booking[0].BookingTypeDisplayArea : 0;

            if (displayAreasState.displayAreas !== undefined && displayAreasState.displayAreas.length > 0) {
                actionGetExtraItems(dispatch, displayareaNo, true, true, startFilterDate, null, "SingleDay");
            }
            else {
                actionGetExtraItems(dispatch, displayareaNo, true, true, startFilterDate, null, "SingleDay");
            }
        }

    }, [displayAreasState.displayAreas]);



    const ConstRedirectCHangeDateTime = (booking) => {

        if (booking) {
            if (booking.AllowDateTimeChanges && booking.AllowDateTimeChangesWithinArea === false) {
                props.history.push({
                    pathname: '/calendar/' + booking.BookingTypeID
                })
            }
            if (booking.hasOwnProperty('BookingTypeDisplayArea') && booking.AllowDateTimeChanges && booking.AllowDateTimeChangesWithinArea) {
                props.history.push({
                    pathname: '/calendar/Area/' + booking.BookingTypeDisplayArea
                })
            }
        }
    }

    const ConstRedirectModifyTickets = () => {

        if (reducerBooking.booking[0] && reducerBooking.booking[0].TourEventID) {
            props.history.push({
                pathname: '/modifytickets',
                toureventID: reducerBooking.booking[0].TourEventID
            })
        }
    }

    const CancelBooking = () => {

        if (totalpayments() === 0) {
            //actionShopCartSetRefundType(dispatch, "CancelBooking");
            applyrefund('CancelBooking');

        }
        else if (reducerBooking.booking[0]) {
            handleClickOpenPaymentMethod();
        }
    }

    const constredirecttofindmybpooking = () => {

        actionResetBooking(dispatch);
        actionShopCartSetManageMyBooking(dispatch, false, false);
        actionShopCartResetMembership(dispatch);
        actionShopCartResetIDME(dispatch);

        props.history.push({
            pathname: '/findmybooking'
        })

    }

    const redirecttofindmybpooking = () => {

        props.history.push({
            pathname: '/findmybooking'
        })
    }

    const reditecttocheckout = () => {

        let BalanceOwe = reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BalanceOwing') && reducerBooking.booking[0].BalanceOwing > 0 ? reducerBooking.booking[0].BalanceOwing : 0;

        if (BalanceOwe > 0) {
            actionShopCartSetRefundType(dispatch, "AdditionalPayment");

            BalanceOwe = addTransFeeWithBalance(BalanceOwe);

            actionShopCartSetMmbAmountToPay(dispatch, BalanceOwe);

            props.history.push({
                pathname: '/managecheckout',
                refundType: 'AdditionalPayment'
            })
        }
    }

    const addTransFeeWithBalance = (balanceOwe) => {

        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            if (transactionfee.transactionFee[0].TransactionFeeByDefault) {
                let transFee = genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], balanceOwe, cashlesstotal)

                if (transFee > 0) {
                    actionShopCartSetEnteredAmountToPay(dispatch, balanceOwe);
                    return genfunction.Rounded(balanceOwe + transFee);
                }
            }
        }
        return balanceOwe;
    }

    const totalpaid = () => {
        let total = 0;
        if (reducerBooking.booking && reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BookingPayments') && reducerBooking.booking[0].BookingPayments.length > 0) {
            total = reducerBooking.booking[0].BookingPayments.map(({ PaymentAmount }) => PaymentAmount).reduce((sum, i) => sum + i, 0);
        }

        return total;
    }

    const totalpayments = () => {
        let total = 0;
        if (reducerBooking.booking && reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BookingPayments') && reducerBooking.booking[0].BookingPayments.length > 0) {
            total = reducerBooking.booking[0].BookingPayments.length;
        }

        return total;
    }

    const applyrefund = (type) => {

        actionShopCartSetMmbAmountToPay(dispatch, - totalpaid());
        actionShopCartSetRefundType(dispatch, type);

        props.history.push({
            pathname: '/managecheckout',
            refundType: type
        })
    }

    const eligibletxtReturnClass = () => {
        let eligibleTxt = "";
        if (reducerBooking.booking[0]) {
            if (reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefunds && totalpayments() === 1 && reducerBooking.booking[0].AllowRefundToGiftcardOnly) {

                if (reducerBooking.booking[0].hasOwnProperty('PaymentToken')) {
                    eligibleTxt = "You are eligible for a refund of" + (reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0) + " to a gift card or card on file " + (reducerBooking.booking[0].PaymentDescription !== undefined ? reducerBooking.booking[0].PaymentDescription : '');
                }
                else {
                    eligibleTxt = "You are eligible for a refund of" + (reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0) + " to a gift card.";
                }
            }
            else if (reducerBooking.booking[0].AllowRefundToGiftcardOnly && reducerBooking.booking[0].AllowRefunds == false) {
                eligibleTxt = "You are eligible for a refund of" + (reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0) + " to a gift card.";
            }
            else if (reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefunds && totalpayments() === 1 && reducerBooking.booking[0].hasOwnProperty('PaymentToken')) {
                eligibleTxt = "You are eligible for a refund of " + (reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0) + " through card on file " + (reducerBooking.booking[0].PaymentDescription !== undefined ? reducerBooking.booking[0].PaymentDescription : '');
            }
            else if (reducerBooking.booking[0] && (reducerBooking.booking[0].AllowRefunds || reducerBooking.booking[0].AllowRefundToGiftcardOnly) && totalpayments() > 1) {
                eligibleTxt = "You are eligible for a refund of" + (reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0) + " to a gift card.";
            }
            return eligibleTxt;
        }
    }

    const totalbookingcost = () => {
        let total = 0;
        if (reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BookingProducts') && reducerBooking.booking[0].BookingProducts.length > 0) {
            total = reducerBooking.booking[0].BookingProducts.map(({ ProductLinePriceInclTax }) => ProductLinePriceInclTax).reduce((sum, i) => sum + i, 0);
        }

        return total;
    }

    const CancelGCRefund = () => {
        applyrefund('CancelGiftCardRefund');
        //actionShopCartSetRefundType(dispatch, "CancelGiftCardRefund");
    }


    return (

        //Desktop and Laptop (smDown)
        //Tablet (xsDown mdUp)
        //Mobile (smUp)

        <Container className={classes.root}>
            <ErrorHandling msg={errorMsg && errorMsg.length > 0 ? errorMsg : ''}
                open={errorMsg && errorMsg.length > 0 ? true : false} handleclose={errorcancelhandle} />

            <Grid container justify="center" spacing={1} className={reducerBooking.booking[0] && reducerBooking.booking[0].BookingID ? '' : classes.hideBtn}>
                <Grid item xs={12} md={7} >
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            {reducerBooking.booking[0] ? reducerBooking.booking[0].BookingName : ''}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderboxMobView} align="center" variant="h3" style={{ padding: "5px" }}>
                            {reducerBooking.booking[0] ? reducerBooking.booking[0].BookingName : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderboxMobView} align="center" variant="h4" style={{ padding: "7px" }}>
                            {reducerBooking.booking[0] ? reducerBooking.booking[0].BookingName : ''}
                        </Typography>
                    </Hidden>


                    <Grid item xs={12} md={12} align="center">
                        <img className={classes.image}
                            alt="Logo"
                            src={DataAccess.apiUrl + 'Barcode/?barcode=\\' + (reducerBooking.booking[0] ? reducerBooking.booking[0].BookingID : '') + "&includeLable=" + ShowReadableBarcode} />

                        <Typography variant="h5" className={classes.warningMsg}>
                            {reducerBooking.booking[0] ? reducerBooking.booking[0].NoChangesMessage : ''}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid item xs={12} md={7} style={{ padding: "15px" }} >
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            Booking Details
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: "5px" }}>
                            Booking Details
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: "7px" }}>
                            Booking Details
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Confirmation Number : {reducerBooking.booking[0] ? reducerBooking.booking[0].BookingID : ''}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Confirmation Number : {reducerBooking.booking[0] ? reducerBooking.booking[0].BookingID : ''}
                        </Typography>
                    </Hidden>
                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Confirmation Number : {reducerBooking.booking[0] ? reducerBooking.booking[0].BookingID : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Name : {reducerBooking.booking[0] ? reducerBooking.booking[0].CustomerName : ''}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Name : {reducerBooking.booking[0] ? reducerBooking.booking[0].CustomerName : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Name : {reducerBooking.booking[0] ? reducerBooking.booking[0].CustomerName : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Date : {reducerBooking.booking[0] ? Moment(reducerBooking.booking[0].EventStartDateTime).format('MMM D, YYYY') : ''}
                        </Typography>
                    </Hidden>
                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Date : {reducerBooking.booking[0] ? Moment(reducerBooking.booking[0].EventStartDateTime).format('MMM D, YYYY') : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Date : {reducerBooking.booking[0] ? Moment(reducerBooking.booking[0].EventStartDateTime).format('MMM D, YYYY') : ''}
                        </Typography>
                    </Hidden>


                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Start Time : {reducerBooking.booking[0] ? Moment(reducerBooking.booking[0].EventStartDateTime).format('hh:mm a') : ''}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Start Time : {reducerBooking.booking[0] ? Moment(reducerBooking.booking[0].EventStartDateTime).format('hh:mm a') : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Start Time : {reducerBooking.booking[0] ? Moment(reducerBooking.booking[0].EventStartDateTime).format('hh:mm a') : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            End Time : {reducerBooking.booking[0] ? Moment(reducerBooking.booking[0].EventEndDateTime).format('hh:mm a') : ''}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            End Time : {reducerBooking.booking[0] ? Moment(reducerBooking.booking[0].EventEndDateTime).format('hh:mm a') : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            End Time : {reducerBooking.booking[0] ? Moment(reducerBooking.booking[0].EventEndDateTime).format('hh:mm a') : ''}
                        </Typography>
                    </Hidden>


                    <Grid item xs={12} md={12} align="center" style={{ padding: "12px" }}>

                        <Hidden smDown>
                            <Button variant="contained" size="medium" color="primary"
                                className={reducerBooking.booking[0]
                                    && reducerBooking.booking[0] !== undefined
                                    && !reducerBooking.booking[0].AllowRefunds
                                    && totalpaid() !== 0
                                    || (reducerBooking.booking[0] !== undefined && reducerBooking.booking[0].hasOwnProperty('BalanceOwing')
                                        && reducerBooking.booking[0].BalanceOwing > 0)
                                    ? classes.hideBtn : ''}
                                style={{ padding: "12px", marginTop: 0 }} onClick={handleClickOpen}>
                                Cancel Booking
                            </Button>

                            <Button variant="contained" size="medium" color="primary"
                                style={{ padding: "12px", marginLeft: "10px", marginTop: 0 }}
                                onClick={() => ConstRedirectCHangeDateTime(reducerBooking.booking[0])}
                                className={reducerBooking.booking[0]
                                    && reducerBooking.booking[0] !== undefined
                                    && !reducerBooking.booking[0].AllowDateTimeChanges ? classes.hideBtn : ''}  >
                                Change Date/Time
                            </Button>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Button variant="contained" size="small" color="primary"
                                className={reducerBooking.booking[0]
                                    && reducerBooking.booking[0] !== undefined
                                    && !reducerBooking.booking[0].AllowRefunds
                                    && totalpaid() !== 0
                                    || (reducerBooking.booking[0] !== undefined && reducerBooking.booking[0].hasOwnProperty('BalanceOwing')
                                        && reducerBooking.booking[0].BalanceOwing > 0)
                                    ? classes.hideBtn : ''}
                                style={{ padding: "12px", marginTop: 10 }} onClick={handleClickOpen}>
                                Cancel Booking
                            </Button>

                            <Button variant="contained" size="small" color="primary"
                                style={{ padding: "12px", marginLeft: "10px", marginTop: 10 }}
                                onClick={() => ConstRedirectCHangeDateTime(reducerBooking.booking[0])}
                                className={reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined 
								&& !reducerBooking.booking[0].AllowDateTimeChanges ? classes.hideBtn : ''}  >
                                Change Date/Time
                            </Button>
                        </Hidden>

                        <Hidden smUp>
                            <Button variant="contained" size="small" color="primary"
                                className={reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined
                                    && !reducerBooking.booking[0].AllowRefunds
                                    && totalpaid() !== 0
                                    || (reducerBooking.booking[0] !== undefined && reducerBooking.booking[0].hasOwnProperty('BalanceOwing') && reducerBooking.booking[0].BalanceOwing > 0)
                                    ? classes.hideBtn : ''}
                                style={{ padding: "12px", marginTop: 10 }} onClick={handleClickOpen}>
                                Cancel Booking
                            </Button>

                            <Button variant="contained" size="small" color="primary"
                                style={{ padding: "12px", marginLeft: "10px", marginTop: 10 }}
                                onClick={() => ConstRedirectCHangeDateTime(reducerBooking.booking[0])}
                                className={reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined && !reducerBooking.booking[0].AllowDateTimeChanges ? classes.hideBtn : ''}  >
                                Change Date/Time
                            </Button>
                        </Hidden>

                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            disableEscapeKeyDown={true}
                            disableBackdropClick={true}
                        >
                            <DialogTitle id="alert-dialog-title">{"Cancel Booking?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">

                                    <Hidden smDown>
                                        <Typography align="center" variant="h5" style={{ padding: "5px" }}>
                                            Are you sure you want to cancel Booking ID {reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined ? reducerBooking.booking[0].BookingID : ''}?
                                        </Typography>
                                    </Hidden>
                                    <Hidden xsDown mdUp>
                                        <Typography align="center" variant="h6" style={{ padding: "5px" }}>
                                            Are you sure you want to cancel Booking ID {reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined ? reducerBooking.booking[0].BookingID : ''}?
                                        </Typography>
                                    </Hidden>
                                    <Hidden smUp>
                                        <Typography align="center" variant="h6" style={{ padding: "5px" }}>
                                            Are you sure you want to cancel Booking ID {reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined ? reducerBooking.booking[0].BookingID : ''}?
                                        </Typography>
                                    </Hidden>

                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Hidden smDown>
                                    <Button onClick={handleClose} variant="outlined" size="medium" color="primary">
                                        Go Back
                                    </Button>
                                    <Button onClick={CancelBooking} variant="contained" size="medium" color="primary" autoFocus>
                                        Cancel Entire Booking
                                    </Button>
                                </Hidden>

                                <Hidden xsDown mdUp>

                                    <Button onClick={handleClose} variant="outlined" size="small" color="primary">
                                        Go Back
                                    </Button>
                                    <Button onClick={CancelBooking} variant="contained" size="small" color="primary" autoFocus>
                                        Cancel Entire Booking
                                    </Button>
                                </Hidden>

                                <Hidden smUp>

                                    <Button onClick={handleClose} variant="outlined" size="small" color="primary">
                                        Go Back
                                    </Button>
                                    <Button onClick={CancelBooking} variant="contained" size="small" color="primary" autoFocus>
                                        Cancel Entire Booking
                                    </Button>
                                </Hidden>

                            </DialogActions>
                        </Dialog>

                    </Grid>
                </Grid>

                <Grid item xs={12} md={7} style={{ padding: "15px" }}>
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            Tickets
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: "5px" }}>
                            Tickets
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: "7px" }}>
                            Tickets
                        </Typography>
                    </Hidden>


                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Tickets
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Tickets
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Tickets
                        </Typography>
                    </Hidden>

                    {reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BookingProducts') && reducerBooking.booking[0].BookingProducts ?

                        reducerBooking.booking[0].BookingProducts.filter(x => x.AffectsCapacity).map(prod => (

                            <>

                                <Hidden smDown>
                                    <Typography variant="h5" style={{ padding: "15px", marginLeft: "10px" }} key={prod.TourProductID}>
                                        {prod.Quantity} x {prod.TourProductName} {"   "}  {genfunction.ccyFormat(prod.ProductLinePriceInclTax)}
                                    </Typography>
                                </Hidden>

                                <Hidden xsDown mdUp>
                                    <Typography variant="h6" style={{ padding: "15px", marginLeft: "10px" }} key={prod.TourProductID}>
                                        {prod.Quantity} x {prod.TourProductName} {"   "}  {genfunction.ccyFormat(prod.ProductLinePriceInclTax)}
                                    </Typography>
                                </Hidden>

                                <Hidden smUp>
                                    <Typography variant="h6" style={{ padding: "15px", marginLeft: "10px" }} key={prod.TourProductID}>
                                        {prod.Quantity} x {prod.TourProductName} {"   "}  {genfunction.ccyFormat(prod.ProductLinePriceInclTax)}
                                    </Typography>
                                </Hidden>
                            </>
                        ))

                        : ''}

                    {reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BookingProducts') && reducerBooking.booking[0].BookingProducts.filter(x => x.AffectsCapacity === false).length > 0 ?
                        <>
                            <Hidden smDown>
                                <Typography variant="h5" className={classes.AdjustContext}>
                                    Add Ons
                                </Typography>
                            </Hidden>

                            <Hidden xsDown mdUp>
                                <Typography variant="h6" className={classes.AdjustContext}>
                                    Add Ons
                                </Typography>
                            </Hidden>

                            <Hidden smUp>
                                <Typography variant="h6" className={classes.AdjustContext}>
                                    Add Ons
                                </Typography>
                            </Hidden>

                        </>
                        : null}

                    {reducerBooking.booking[0] && reducerBooking.booking[0].BookingProducts ?

                        reducerBooking.booking[0].BookingProducts.filter(x => x.AffectsCapacity === false).map(prod => (

                            <>

                                <Hidden smDown>
                                    <Typography variant="h5" style={{ padding: "15px", marginLeft: "10px" }}>
                                        {prod.Quantity} x {prod.TourProductName} {"   "}  {genfunction.ccyFormat(prod.ProductLinePriceInclTax)}
                                    </Typography>
                                </Hidden>

                                <Hidden xsDown mdUp>
                                    <Typography variant="h6" style={{ padding: "15px", marginLeft: "10px" }}>
                                        {prod.Quantity} x {prod.TourProductName} {"   "}  {genfunction.ccyFormat(prod.ProductLinePriceInclTax)}
                                    </Typography>
                                </Hidden>

                                <Hidden smUp>
                                    <Typography variant="h6" style={{ padding: "15px", marginLeft: "10px" }}>
                                        {prod.Quantity} x {prod.TourProductName} {"   "}  {genfunction.ccyFormat(prod.ProductLinePriceInclTax)}
                                    </Typography>
                                </Hidden>

                            </>

                        ))

                        : ''}

                    <Grid item xs={12} md={12} align="center">

                        <Hidden smDown>
                            <Button variant="contained" size="medium" color="primary" style={{ padding: "12px" }}
                                className={reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined && reducerBooking.booking[0].AllowTicketChanges ? '' : classes.hideBtn}
                                onClick={() => ConstRedirectModifyTickets()}>
                                Modify Tickets & Add  Ons
                            </Button>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Button variant="contained" size="small" color="primary" style={{ padding: "12px" }}
                                className={reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined && reducerBooking.booking[0].AllowTicketChanges ? '' : classes.hideBtn}
                                onClick={() => ConstRedirectModifyTickets()}>
                                Modify Tickets & Add  Ons
                            </Button>
                        </Hidden>

                        <Hidden smUp>
                            <Button variant="contained" size="small" color="primary" style={{ padding: "12px" }}
                                className={reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined && reducerBooking.booking[0].AllowTicketChanges ? '' : classes.hideBtn}
                                onClick={() => ConstRedirectModifyTickets()}>
                                Modify Tickets & Add  Ons
                            </Button>
                        </Hidden>

                    </Grid>

                </Grid>

                <Grid item xs={12} md={7} style={{ padding: "15px" }} >

                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            Payment
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: "5px" }}>
                            Payment
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: "7px" }}>
                            Payment
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Status : {reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BalanceOwing') && reducerBooking.booking[0].BalanceOwing > 0 ? 'Unpaid' : 'Paid'}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Status : {reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BalanceOwing') && reducerBooking.booking[0].BalanceOwing > 0 ? 'Unpaid' : 'Paid'}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Status : {reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BalanceOwing') && reducerBooking.booking[0].BalanceOwing > 0 ? 'Unpaid' : 'Paid'}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Total : {genfunction.ccyFormat(totalbookingcost())}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Total : {genfunction.ccyFormat(totalbookingcost())}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Total : {genfunction.ccyFormat(totalbookingcost())}
                        </Typography>
                    </Hidden>


                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Total Paid : {reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : genfunction.ccyFormat(0)}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Total Paid : {reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : genfunction.ccyFormat(0)}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Total Paid : {reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : genfunction.ccyFormat(0)}
                        </Typography>
                    </Hidden>



                    {reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BalanceOwing') && reducerBooking.booking[0].BalanceOwing > 0 ?
                        <>
                            <Hidden smDown>
                                <Typography variant="h5" className={classes.AdjustContext}>
                                    Balance Owing : {genfunction.ccyFormat(reducerBooking.booking[0].BalanceOwing)}
                                </Typography>
                            </Hidden>

                            <Hidden xsDown mdUp>
                                <Typography variant="h6" className={classes.AdjustContext}>
                                    Balance Owing : {genfunction.ccyFormat(reducerBooking.booking[0].BalanceOwing)}
                                </Typography>
                            </Hidden>

                            <Hidden smUp>
                                <Typography variant="h6" className={classes.AdjustContext}>
                                    Balance Owing : {genfunction.ccyFormat(reducerBooking.booking[0].BalanceOwing)}
                                </Typography>
                            </Hidden>
                        </>

                        : null}


                    <Grid item xs={12} md={12} align="center">
                        <Hidden smDown>
                            <Button variant="outlined" size="medium" color="primary" className={classes.AdjustContext} style={{ padding: "12px" }}
                                onClick={() => constredirecttofindmybpooking()}>
                                Cancel Changes
                            </Button>

                            <Button variant="contained" size="medium" color="primary"
                                className={reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined && reducerBooking.booking[0].BalanceOwing > 0 ? '' : classes.hideBtn}
                                style={{ marginLeft: "10px", padding: "12px" }}
                                onClick={() => reditecttocheckout()}>
                                Make Payment
                            </Button>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Button variant="outlined" size="small" color="primary" className={classes.AdjustContext} style={{ padding: "12px" }}
                                onClick={() => constredirecttofindmybpooking()}>
                                Cancel Changes
                            </Button>

                            <Button variant="contained" size="small" color="primary"
                                className={reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined && reducerBooking.booking[0].BalanceOwing > 0 ? '' : classes.hideBtn}
                                style={{ marginLeft: "10px", padding: "12px" }}
                                onClick={() => reditecttocheckout()}>
                                Make Payment
                            </Button>
                        </Hidden>

                        <Hidden smUp>
                            <Button variant="outlined" size="small" color="primary" className={classes.AdjustContext} style={{ padding: "12px" }}
                                onClick={() => constredirecttofindmybpooking()}>
                                Cancel Changes
                            </Button>

                            <Button variant="contained" size="small" color="primary"
                                className={reducerBooking.booking[0] && reducerBooking.booking[0] !== undefined && reducerBooking.booking[0].BalanceOwing > 0 ? '' : classes.hideBtn}
                                style={{ marginLeft: "10px", padding: "12px" }}
                                onClick={() => reditecttocheckout()}>
                                Make Payment
                            </Button>
                        </Hidden>
                    </Grid>
                </Grid>
            </Grid>

            <Dialog
                open={openPaymentmethod}
                onClose={handleClosePaymentMethod}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
            >
                <DialogTitle id="alert-dialog-title">{"Refund Transaction"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Hidden smDown>
                            <Typography variant="h5" style={{ padding: "10px" }}>
                                {eligibletxtReturnClass()}
                            </Typography>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Typography variant="h6" style={{ padding: "10px" }}>
                                {eligibletxtReturnClass()}
                            </Typography>
                        </Hidden>

                        <Hidden smUp>
                            <Typography variant="h6" style={{ padding: "10px" }}>
                                {eligibletxtReturnClass()}
                            </Typography>
                        </Hidden>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Hidden smDown>
                        <Button onClick={handleClosePaymentMethod} variant="outlined" size="medium" color="primary">
                            Cancel Changes
                        </Button>

                        <Button
                            onClick={() => applyrefund('CancelBooking')}
                            variant="contained" size="medium" color="primary"
                            className={reducerBooking.booking[0] && (reducerBooking.booking[0].AllowRefunds && totalpayments() === 1 && reducerBooking.booking[0].hasOwnProperty('PaymentToken')) ? '' : classes.hideBtn}  >
                            Refund to Credit Card
                        </Button>

                        <Button
                            onClick={() => CancelGCRefund()}
                            variant="contained" size="medium" color="primary"
                            className={reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefundToGiftcardOnly ? '' : classes.hideBtn}  >
                            Refund to Gift Card
                        </Button>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Button onClick={handleClosePaymentMethod} variant="outlined" size="small" color="primary">
                            Cancel Changes
                        </Button>

                        <Button
                            onClick={() => applyrefund('CancelBooking')}
                            variant="contained" size="small" color="primary"
                            className={reducerBooking.booking[0] && (reducerBooking.booking[0].AllowRefunds && totalpayments() === 1 && reducerBooking.booking[0].hasOwnProperty('PaymentToken')) ? '' : classes.hideBtn}  >
                            Refund to Credit Card
                        </Button>

                        <Button
                            onClick={() => CancelGCRefund()}
                            variant="contained" size="small" color="primary"
                            className={reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefundToGiftcardOnly ? '' : classes.hideBtn}  >
                            Refund to Gift Card
                        </Button>
                    </Hidden>

                    <Hidden smUp>
                        <Button onClick={handleClosePaymentMethod} variant="outlined" size="small" color="primary">
                            Cancel Changes
                        </Button>

                        <Button
                            onClick={() => applyrefund('CancelBooking')}
                            variant="contained" size="small" color="primary"
                            className={reducerBooking.booking[0] && (reducerBooking.booking[0].AllowRefunds && totalpayments() === 1 && reducerBooking.booking[0].hasOwnProperty('PaymentToken')) ? '' : classes.hideBtn}  >
                            Refund to Credit Card
                        </Button>

                        <Button
                            onClick={() => CancelGCRefund()}
                            variant="contained" size="small" color="primary"
                            className={reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefundToGiftcardOnly ? '' : classes.hideBtn}  >
                            Refund to Gift Card
                        </Button>
                    </Hidden>

                </DialogActions>
            </Dialog>

            <Grid container justify="center" style={{ minHeight: '10vh', marginTop: 30 }} spacing={1} className={reducerBooking.booking[0] && reducerBooking.booking[0].BookingID ? classes.hideBtn : ''}>
                <Typography variant="h4" className={classes.AdjustContext}>
                    Please go to find my booking page to Update Booking.
                </Typography>
                <Grid item xs={12} md={12} align="center">

                    <Button variant="outlined" size="medium" color="primary" className={classes.AdjustContext} style={{ padding: "12px" }}
                        onClick={() => redirecttofindmybpooking()}>
                        Manage My Booking
                    </Button>
                </Grid>
            </Grid>
        </Container >
    );
};

export default ManageMyBooking;
